import React from 'react';
import styled from 'styled-components';
import t from 'prop-types';
import {Bold, Text} from '../atoms/Text';
import {colors} from '../styles';
import AlarmDot from '../atoms/AlarmDot';
import moment from 'moment';

export const SideBarAlarmContainer = styled.div`
  flex-direction: column;
  padding-bottom: 24px;
  position: relative;
  padding-left: 20px;
  margin-left: -20px;
  padding-right: 8px;
  border-left: 2px solid ${colors.secondary};
`;

const TimeStamp = styled(Text)`
  margin-left: auto;
  font-size: 10px;
  margin-top: 4px;
`;

export const alarmColor = new Map([
  ['YELLOW', colors.alarm.yellow],
  ['ORANGE', colors.alarm.orange],
  ['RED', colors.alarm.red],
  ['BLACK', colors.alarm.black],
  [null, colors.alarm.unknown],
]);

const SideBarAlarm = ({
  alarm: {code = '-', text = '-', start = '-', category},
}) => (
  <SideBarAlarmContainer>
    <div style={{display: 'flex'}}>
      <Bold style={{marginBottom: '6px'}}>{code}</Bold>
      <TimeStamp>{moment(start).fromNow()}</TimeStamp>
    </div>
    <Text style={{fontSize: '10px', textTransform: 'none'}}>
      {text || 'No additional information about this alarm'}
    </Text>
    <AlarmDot
      style={{
        position: 'absolute',
        top: 0,
        left: -6,
        backgroundColor: alarmColor.get(category),
      }}
    />
  </SideBarAlarmContainer>
);

SideBarAlarm.propTypes = {
  alarm: t.objectOf({
    code: t.string,
    text: t.string,
    category: t.string,
    start: t.string,
  }),
};

export default SideBarAlarm;
